<template>
  <h1 class="head">
    产品研发
  </h1>

  <div class="text-[#66626F] mb-6">
    <div class="mb-5 flex text-base">
      <div class="w-[180px] flex-shrink-0 mr-8">检测项目</div>
      <div class="flex-1">检测内容</div>
      <div class="w-[180px] flex-shrink-0 ml-8">样本类型</div>
    </div>

    <div v-for="(item, index) of list"
      :key="index"
      class="flex pb-3.5 mb-3.5 border-b ">
      <div class="w-[180px] flex-shrink-0 mr-8">{{ item.a }}</div>
      <div class="flex-1 whitespace-pre-line">{{ item.b }}</div>
      <div class="w-[180px] flex-shrink-0 ml-8">{{ item.c }}</div>
    </div>
  </div>

  <div class="text-base text-[#66626F] mb-6">
    <div>数据积累</div>
    <div>
      数据量大：真实世界临床检测案例>4万例。10余种癌种，前列腺癌样本6000+；
    </div>
    <div>
      范围广：检测区域覆盖29+省份，覆盖医院>500+，覆盖专家医生＞2000+；
    </div>
  </div>

  <div v-for="(item, index) of imgList"
    :key="index"
    class="mb-8 last:mb-0">
    <div class="mb-4">
      <img :src="item.img"
        class="w-full">
    </div>
    <div class="text-base text-center text-[#0D0223]">{{ item.label }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          a: '肿瘤个体化诊疗基因检测',
          b: '1.检测TMB，tMSI等免疫相关生物标志物；\n2.检测642基因的全部外显子区域、部分融合相关内含子区域，囊括肿瘤发生发展重要通路包括DNA损伤修复通路，PI3K-AKT-mTOR通路，Wnt通路，FGF/FGFR通路，RAS-RAF-MAPK通路，细胞周期通路，AR相关通路，ER相关通路，血管生成通路等，通过对DNA水平上相关基因的单核苷酸变异（SNV）、小片段插入/缺失变异（INDEL）、拷贝数变异（CNV）、捕获范围内的基因重排（Fusion）等进行检测；',
          c: '组织+对照血或血液'
        },
        {
          a: '肿瘤全外显子检测',
          b: '1.检测TMB，tMSI等免疫相关生物标志物；\n 2.检测全部2万多个基因的全部外显子区域，囊括肿瘤发生发展重要通路包括DNA损伤修复通路，PI3K-AKT-mTOR通路，Wnt通路，FGF/FGFR通路，RAS-RAF-MAPK通路，细胞周期通路，AR相关通路，ER相关通路，血管生成通路等，分析DNA水平上相关基因的单核苷酸变异（SNV）、小片段插入/缺失变异（INDEL）、拷贝数变异（CNV）等；',
          c: '组织+对照血'
        },
        {
          a: '肿瘤全转录组检测',
          b: '对全转录组(mRNA)检测\n1.检测IFN-γ相关肿瘤炎性免疫微环境数值（GEP），淋巴细胞浸润分布等免疫相关生物标志物；\n2.检测基因融合；',
          c: '组织'
        },
        {
          a: 'HRR基因检测',
          b: '涵盖PARPi伴随诊断的HRR 14基因，BRCA1/2，ATM，CDK12，PALB2等；',
          c: '组织+对照血或血液'
        },
        {
          a: 'HRD基因检测',
          b: '1. 均匀覆盖于整个人类基因组、并专门针对中国人设计的52000+SNPs位点检测；\n2. 28个HRR基因的突变情况（完全涵盖PROfound三期临床研究中获批于FDA的14个HRR基因）；',
          c: '组织+对照血'
        },
        {
          a: 'PD-L1表达检测',
          b: '在蛋白层面上对肿瘤细胞的PD-L1进行解析，通过免疫组化技术，检测PD-L1蛋白表达水平；',
          c: '组织'
        },
        {
          a: '定制化panel',
          b: '根据需求可进行定制化panel设计、SNP位点检测；',
          c: '具体可根据项目需求做定制'
        }
      ],

      imgList: [
        {
          label: '产品研发-HDR',
          img: require('@/assets/homes/service/products/img-0.png')
        },
        {
          label: '产品研发-MDR',
          img: require('@/assets/homes/service/products/img-1.png')
        },
        {
          label: '结直肠癌血液NGS检测',
          img: require('@/assets/homes/service/products/img-2.png')
        },
        {
          label: '膀胱癌尿液甲基化检测',
          img: require('@/assets/homes/service/products/img-3.png')
        },
        {
          label: '甲基化测序技术路线',
          img: require('@/assets/homes/service/products/img-4.png')
        },
        {
          label: '图：甲基化在基因组上的分布',
          img: require('@/assets/homes/service/products/img-5.png')
        },
        {
          label: '图：甲基化变化规律及不同甲基化类型之间的关系',
          img: require('@/assets/homes/service/products/img-6.png')
        },
        {
          label: '单细胞测序技术路线',
          img: require('@/assets/homes/service/products/img-7.png')
        },
        {
          label: '图：细胞类群个数选择',
          img: require('@/assets/homes/service/products/img-8.png')
        },
        {
          label: '图：细胞分群',
          img: require('@/assets/homes/service/products/img-9.png')
        },
        {
          label: '图：细胞拟时序分析',
          img: require('@/assets/homes/service/products/img-10.png')
        },
      ]
    }
  }
}
</script>

<style>
</style>